/* TasteTwelve Warenkorb-Schublade (19.10.2026)
   1. Minus/Plus am Mengenfeld (snippets/line-item.liquid, sections/main-cart.liquid): Wert setzen und gebündelt das
      change-Ereignis auslösen, das line-item-quantity des Themes ohnehin verarbeitet (cart/change.js, Schublade wird
      neu gezeichnet, Warenkorbseite lädt neu).
   2. Geschenkbox-Zeile und Städte-Chips (snippets/t12-schublade-extras.liquid): cart/add.js, danach cart:refresh,
      damit Theme-Schublade und Zähler den neuen Stand vom Server holen.
   Ereignisdelegation am Dokument, weil das Theme den Inhalt der Schublade bei jeder Änderung austauscht. */
(function () {
  if (window.t12Warenkorb) return;
  window.t12Warenkorb = true;
  var wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Schnelle Klicks bündeln: Das Theme schickt je change-Ereignis eine eigene cart/change-Anfrage mit der Zielmenge und
     lädt auf der Warenkorbseite danach neu. Erst 400 ms nach dem letzten Klick wird eine Anfrage mit der Endmenge
     gestellt, so laufen keine Anfragen gegeneinander und kein Klick geht im Neuladen verloren. */
  var WARTEZEIT = 400;
  var offen = [];

  /* Expressknöpfe (sections/cart-drawer.liquid) gehen am Kassenformular vorbei und lesen den Warenkorb vom Server.
     Solange eine Menge aussteht, sind sie gesperrt; frei, sobald das Theme cart:change meldet (die Schublade wird dabei
     ohnehin neu gezeichnet). Fail-open: spätestens nach 4 s wieder frei, auch wenn die Anfrage scheitert. */
  function express(sperren) {
    document.querySelectorAll('[data-t12-express]').forEach(function (el) {
      el.inert = sperren;
      el.classList.toggle('is-wartend', sperren);
      clearTimeout(el.t12Frei);
      if (sperren) el.t12Frei = setTimeout(function () { express(false); }, 4000);
    });
  }
  document.addEventListener('cart:change', function () { if (!offen.length) express(false); });

  /* Nur PayPal zeigen: Shopify reserviert für jede Wallet des Browsers eine Zeile, auch wenn ihr Knopf per CSS
     ausgeblendet ist, und in Safari steht Apple Pay vor PayPal. Deshalb den Rahmen auf die PayPal-Zeile zuschneiden.
     Die Knöpfe entstehen erst nach dem Laden und nach jedem Neuzeichnen der Schublade, daher der Beobachter.
     Fail-open: ohne sichtbaren PayPal-Knopf bleibt der Rahmen, wie Shopify ihn zeigt. */
  var groesse = window.ResizeObserver ? new ResizeObserver(function () { nurPaypal(); }) : null;
  function nurPaypal() {
    document.querySelectorAll('[data-t12-express] .additional-checkout-buttons').forEach(function (rahmen) {
      var wirt = rahmen.querySelector('shopify-accelerated-checkout-cart');
      var knopf = rahmen.querySelector('shopify-paypal-button');
      if (wirt && groesse && !wirt.t12Beobachtet) { wirt.t12Beobachtet = true; groesse.observe(wirt); }
      if (!wirt || !knopf || !knopf.offsetHeight) {
        rahmen.style.height = rahmen.style.overflow = '';
        if (wirt) wirt.style.marginTop = '';
        return;
      }
      wirt.style.display = 'block';
      wirt.style.marginTop = '';
      var versatz = knopf.getBoundingClientRect().top - wirt.getBoundingClientRect().top;
      wirt.style.marginTop = -versatz + 'px';
      rahmen.style.height = knopf.offsetHeight + 'px';
      rahmen.style.overflow = 'hidden';
    });
  }
  var zuschnitt;
  new MutationObserver(function (liste) {
    for (var i = 0; i < liste.length; i++) {
      var ziel = liste[i].target;
      if (ziel.closest && ziel.closest('[data-t12-express], cart-drawer')) {
        clearTimeout(zuschnitt);
        zuschnitt = setTimeout(nurPaypal, 50);
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var schritt = e.target.closest ? e.target.closest('[data-t12-schritt]') : null;
    if (schritt) {
      var menge = schritt.closest('.t12-menge');
      var feld = menge.querySelector('.quantity-input');
      var alt = parseInt(feld.value, 10) || 1;
      var neu = Math.max(1, alt + parseInt(schritt.getAttribute('data-t12-schritt'), 10));
      if (feld.max) neu = Math.min(neu, parseInt(feld.max, 10));
      if (neu === alt) return;
      feld.value = neu;
      var minus = menge.querySelector('[data-t12-schritt="-1"]');
      if (minus) minus.disabled = neu <= 1;
      clearTimeout(feld.t12Zeit);
      if (offen.indexOf(feld) < 0) offen.push(feld);
      express(true);
      feld.t12Zeit = setTimeout(function () {
        offen.splice(offen.indexOf(feld), 1);
        if (feld.isConnected) feld.dispatchEvent(new Event('change', { bubbles: true }));
      }, WARTEZEIT);
      return;
    }

    var dazu = e.target.closest ? e.target.closest('[data-t12-dazu]') : null;
    if (!dazu || dazu.disabled) return;
    e.preventDefault();
    dazu.disabled = true;
    dazu.classList.add('is-loading');
    fetch(wurzel + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(dazu.getAttribute('data-t12-dazu'), 10),
                                       quantity: parseInt(dazu.getAttribute('data-t12-menge') || '1', 10) }] })
    }).then(function (antwort) {
      if (!antwort.ok) throw new Error('add');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () {
      dazu.disabled = false;
      dazu.classList.remove('is-loading');
    });
  });

  /* Zur Kasse innerhalb der Wartezeit: ausstehende Mengen erst an den Warenkorb schicken, dann mit demselben Knopf
     absenden. Ohne ausstehende Mengen greift dieser Teil nicht, der Kassenweg bleibt dann unverändert. */
  document.addEventListener('submit', function (e) {
    if (!offen.length) return;
    var formular = e.target;
    var knopf = e.submitter;
    /* Ältere Safari-Versionen kennen e.submitter nicht; dann den Kassenknopf nehmen, sonst landet der Kunde auf /cart. */
    var kasse = formular.querySelector('button[name="checkout"], input[name="checkout"]');
    if ((!knopf || knopf.form !== formular) && kasse) knopf = kasse;
    e.preventDefault();
    var auftraege = offen.map(function (feld) {
      clearTimeout(feld.t12Zeit);
      return fetch(wurzel + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: feld.getAttribute('data-line-key'), quantity: parseInt(feld.value, 10) })
      }).catch(function () {});
    });
    offen = [];
    Promise.all(auftraege).then(function () {
      if (formular.requestSubmit && knopf) {
        formular.requestSubmit(knopf);
      } else {
        if (knopf && knopf.name) {
          var verdeckt = document.createElement('input');
          verdeckt.type = 'hidden';
          verdeckt.name = knopf.name;
          verdeckt.value = knopf.value || '';
          formular.appendChild(verdeckt);
        }
        formular.submit();
      }
    });
  }, true);
})();
